import React from 'react';

import ArticleFeedItem from '@components/FeedItems/ArticleFeedItem';
import BriefingFeedItem from '@components/FeedItems/BriefingFeedItem';
import TITVStreamFeedItem from '@components/FeedItems/TITVStreamFeedItem';
import { Author } from '@interfaces/authors';
import { FeedContentType } from '@utils/enums';

import { Briefing } from '../../../interfaces/homepage';

export type ArticleOrBriefing = {
  authors: Author[];
  commentsCount: number;
  dek?: string;
  excerpt: { short: string; long: string };
  guid: string;
  headline?: string;
  highlight: string;
  id: number;
  isPro?: boolean;
  picture: string | null;
  publishOnWeb: boolean;
  publishedAt?: string;
  slug: string;
  url?: string;
  title?: string;
  type: FeedContentType.Article | FeedContentType.Briefing | FeedContentType.TITVStream;
  newsletterSlug?: string;
  // TITVStream-only fields
  coverUrl?: string;
  datetime?: string;
};

interface ArticleOrBriefingFeedItemProps {
  articleOrBriefing: ArticleOrBriefing;
}

export default function ArticleOrBriefingFeedItem({
  articleOrBriefing,
}: ArticleOrBriefingFeedItemProps) {
  const { type, ...rest } = articleOrBriefing;

  return (
    <div id={`${type.toLowerCase()}-${rest.id}`} data-test="article-or-briefing-feed-item">
      {type === FeedContentType.Article && <ArticleFeedItem {...rest} />}
      {type === FeedContentType.Briefing && (
        <BriefingFeedItem briefing={articleOrBriefing as Briefing} />
      )}
      {type === FeedContentType.TITVStream && (
        <TITVStreamFeedItem
          titvStream={{
            contentType: FeedContentType.TITVStream,
            coverUrl: rest.coverUrl ?? '',
            datetime: rest.datetime ?? '',
            guid: rest.guid,
            id: rest.id,
            title: rest.title ?? '',
          }}
        />
      )}
    </div>
  );
}
